import { motion } from 'framer-motion';
import { useContext, useMemo } from 'react';
import { useTranslate } from 'sbx-crm-menu-ui';
import { TextAreaTranslateComponent } from 'src/components/shared/TextAreaTranslateComponent';
import { AiAgentV2Data } from '../../../../types/AiAgentV2';
import RenderFormFieldsComponent, {
    GroupTypes,
} from '../../../shared/renderFormFieldsComponent/RenderFormFieldsComponent';
import { Card, CardContent, CardHeader, CardTitle } from '../../../ui/card';
import { AgentSetupContext } from '../AgentSetupComponent';
import { AppAgentContext } from 'src/context/ContextProvider';
import { grantPermission } from 'src/utils';
import { AI_AGENT_V2_EDIT } from 'src/types/Permission';
import { useParams } from 'react-router-dom';

const classNameLabel = 'text-purple-700 font-semibold';
const classNameInput =
    '!border-purple-300 !focus:border-purple-500 !focus:ring !focus:ring-purple-200 !focus:ring-opacity-50';

const AgentBehaviorComponent = () => {
    const { permissions } = useContext(AppAgentContext).state.session;
    const { t: agent } = useTranslate('agent');
    const { control, behaviorOptions, setValue, getValues, watch } = useContext(AgentSetupContext);
    const { id } = useParams();

    const allowEdit = useMemo(() => {
        return grantPermission(AI_AGENT_V2_EDIT, permissions);
    }, [permissions]);

    const behaviorFields = useMemo((): GroupTypes<keyof AiAgentV2Data> => {
        return {
            behavior: {
                columns: 'grid-cols-1 mb-3',
                items: [
                    {
                        name: 'behavior_name',
                        label: agent('behavior_name'),
                        placeholder: agent('behavior_name'),
                        classNameLabel,
                        classNameInput,
                        type: 'select',
                        options: behaviorOptions,
                        onChange: (value: string) => {
                            const behavior = behaviorOptions?.find((option) => option.value === value);
                            if (behavior?.data) {
                                setValue('behavior', behavior.data);
                            }
                        },
                        disabled: id !== 'create' && !allowEdit,
                        rules: {
                            required: false,
                        },
                    },
                    // },
                    // {
                    //     name: 'greeting',
                    //     label: agent('greeting'),
                    //     classNameLabel,
                    //     classNameInput,
                    //     placeholder: agent('greeting'),
                    //     type: 'textarea',
                    //     rules: {
                    //         required: true,
                    //     },
                    // }
                ],
            },
        };
    }, [behaviorOptions]);

    return (
        <Card className="bg-gradient-to-br from-purple-100 to-pink-100 shadow-xl">
            <CardHeader>
                <CardTitle className="text-2xl font-bold text-purple-800">{agent('behavior_settings')}</CardTitle>
            </CardHeader>
            <CardContent className="space-y-6 flex flex-col">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                >
                    <div className={`grid ${behaviorFields['behavior'].columns ?? 'grid-cols-1 '} gap-3 mb-3`}>
                        <RenderFormFieldsComponent fields={behaviorFields['behavior'].items} control={control} />
                    </div>

                    <TextAreaTranslateComponent
                        originalPlaceholder={agent('greeting')}
                        translatePlaceholder={agent('greeting')}
                        keyFormOriginal="greeting"
                        keyFormTranslate="greeting_en"
                        label={agent('greeting')}
                        getValues={getValues}
                        setValue={setValue}
                        watch={watch}
                        disabled={id !== 'create' && !allowEdit}
                    />
                </motion.div>
            </CardContent>
        </Card>
    );
};

export default AgentBehaviorComponent;
